{
  "verified": "2026-09-13",
  "url": "https://ec.europa.eu/eurostat/api/dissemination/statistics/1.0/data/isoc_eb_iip?lang=en&time=2025&indic_is=E_CRM1&unit=PC_ENT",
  "sha256": "689e299297ce4539ac86e3dff760e64593626e02072d84debd250bdfde8ec3b1",
  "updated": "2026-02-27T11:00:00+0100",
  "industryUrl": "https://ec.europa.eu/eurostat/api/dissemination/statistics/1.0/data/isoc_eb_iipn2?lang=en&time=2025&indic_is=E_CRM1&unit=PC_ENT&geo=EU27_2020&size_emp=GE10",
  "industrySha256": "e9b24ddc3d7a25324a90dbfb0554496be52d328ac7a48df2e1d9fdb519532f5e",
  "countries": [
    {
      "code": "EU27_2020",
      "label": "European Union - 27 countries (from 2020)",
      "values": [
        {
          "index": 336,
          "value": 28.51,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 252,
          "value": 24.69,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 378,
          "value": 43.77,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 420,
          "value": 65.43,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "BE",
      "label": "Belgium",
      "values": [
        {
          "index": 342,
          "value": 41.42,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 258,
          "value": 36.29,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 384,
          "value": 59.74,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 426,
          "value": 77.14,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "BG",
      "label": "Bulgaria",
      "values": [
        {
          "index": 343,
          "value": 11.92,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 259,
          "value": 10.43,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 385,
          "value": 16.75,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 427,
          "value": 33.1,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "CZ",
      "label": "Czechia",
      "values": [
        {
          "index": 344,
          "value": 36.21,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 260,
          "value": 30.01,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 386,
          "value": 57.19,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 428,
          "value": 70.14,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "DK",
      "label": "Denmark",
      "values": [
        {
          "index": 345,
          "value": 42.51,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 261,
          "value": 38.02,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 387,
          "value": 57.64,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 429,
          "value": 78.6,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "DE",
      "label": "Germany",
      "values": [
        {
          "index": 346,
          "value": 29.64,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 262,
          "value": 25.95,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 388,
          "value": 43.53,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 430,
          "value": 61.07,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "EE",
      "label": "Estonia",
      "values": [
        {
          "index": 347,
          "value": 20.63,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 263,
          "value": 16.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 389,
          "value": 36.02,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 431,
          "value": 57.42,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "IE",
      "label": "Ireland",
      "values": [
        {
          "index": 348,
          "value": 27.71,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 264,
          "value": 22.67,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 390,
          "value": 49.14,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 432,
          "value": 65.48,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "EL",
      "label": "Greece",
      "values": [
        {
          "index": 349,
          "value": 19.17,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 265,
          "value": 16.4,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 391,
          "value": 31.86,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 433,
          "value": 49.45,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "ES",
      "label": "Spain",
      "values": [
        {
          "index": 350,
          "value": 33.28,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 266,
          "value": 29.38,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 392,
          "value": 47.96,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 434,
          "value": 68.68,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "FR",
      "label": "France",
      "values": [
        {
          "index": 351,
          "value": 30.67,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 267,
          "value": 27.13,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 393,
          "value": 45.58,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 435,
          "value": 73.63,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "HR",
      "label": "Croatia",
      "values": [
        {
          "index": 352,
          "value": 19.07,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 268,
          "value": 16.97,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 394,
          "value": 26.89,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 436,
          "value": 45.62,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "IT",
      "label": "Italy",
      "values": [
        {
          "index": 353,
          "value": 21.73,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 269,
          "value": 19.11,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 395,
          "value": 36.95,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 437,
          "value": 56.53,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "CY",
      "label": "Cyprus",
      "values": [
        {
          "index": 354,
          "value": 33.1,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 270,
          "value": 30.25,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 396,
          "value": 47.95,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 438,
          "value": 58.07,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LV",
      "label": "Latvia",
      "values": [
        {
          "index": 355,
          "value": 17.33,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 271,
          "value": 13.95,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 397,
          "value": 29.6,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 439,
          "value": 54.26,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LT",
      "label": "Lithuania",
      "values": [
        {
          "index": 356,
          "value": 30,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 272,
          "value": 24.94,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 398,
          "value": 44.5,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 440,
          "value": 75.44,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LU",
      "label": "Luxembourg",
      "values": [
        {
          "index": 357,
          "value": 34.01,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 273,
          "value": 29.94,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 399,
          "value": 48.13,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 441,
          "value": 60.29,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "HU",
      "label": "Hungary",
      "values": [
        {
          "index": 358,
          "value": 20.28,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 274,
          "value": 16.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 400,
          "value": 35.4,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 442,
          "value": 61.69,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "MT",
      "label": "Malta",
      "values": [
        {
          "index": 359,
          "value": 39.8,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 275,
          "value": 35.48,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 401,
          "value": 52.42,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 443,
          "value": 71.76,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "NL",
      "label": "Netherlands",
      "values": [
        {
          "index": 360,
          "value": 54.12,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 276,
          "value": 49.61,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 402,
          "value": 69.61,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 444,
          "value": 80.69,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "AT",
      "label": "Austria",
      "values": [
        {
          "index": 361,
          "value": 29.86,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 277,
          "value": 25.39,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 403,
          "value": 48.57,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 445,
          "value": 69.42,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "PL",
      "label": "Poland",
      "values": [
        {
          "index": 362,
          "value": 24.32,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 278,
          "value": 19.23,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 404,
          "value": 42.37,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 446,
          "value": 75.72,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "PT",
      "label": "Portugal",
      "values": [
        {
          "index": 363,
          "value": 21.64,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 279,
          "value": 18.26,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 405,
          "value": null,
          "flag": "u",
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": "low reliability"
        },
        {
          "index": 447,
          "value": 61.72,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "RO",
      "label": "Romania",
      "values": [
        {
          "index": 364,
          "value": 13.93,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 280,
          "value": 11.96,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 406,
          "value": 19.69,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 448,
          "value": 37.65,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SI",
      "label": "Slovenia",
      "values": [
        {
          "index": 365,
          "value": 21.46,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 281,
          "value": 18.02,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 407,
          "value": 31.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 449,
          "value": 68.04,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SK",
      "label": "Slovakia",
      "values": [
        {
          "index": 366,
          "value": 19.72,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 282,
          "value": 15.27,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 408,
          "value": 33.2,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 450,
          "value": 50.22,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "FI",
      "label": "Finland",
      "values": [
        {
          "index": 367,
          "value": 55.79,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 283,
          "value": 51.76,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 409,
          "value": 70.27,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 451,
          "value": 85.93,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SE",
      "label": "Sweden",
      "values": [
        {
          "index": 368,
          "value": 33.89,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 284,
          "value": 28.6,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 410,
          "value": 52.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 452,
          "value": 75.73,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CRM1",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    }
  ],
  "industries": [
    {
      "code": "C",
      "label": "Manufacturing",
      "index": 2,
      "value": 26.22,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "C",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "D_E",
      "label": "Electricity, gas, steam and air conditioning supply; water supply; sewerage, waste management and remediation activities",
      "index": 21,
      "value": 29.74,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "D_E",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "F",
      "label": "Construction",
      "index": 25,
      "value": 16.43,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "F",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "G",
      "label": "Wholesale and retail trade; repair of motor vehicles and motorcycles",
      "index": 26,
      "value": 34.9,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "G",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "H",
      "label": "Transportation and storage",
      "index": 31,
      "value": 18.55,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "H",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "I",
      "label": "Accommodation and food service activities",
      "index": 32,
      "value": 19.72,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "I",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "J",
      "label": "Information and communication",
      "index": 34,
      "value": 63.14,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "J",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "L",
      "label": "Real estate activities",
      "index": 39,
      "value": 39.6,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "L",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "M",
      "label": "Professional, scientific and technical activities",
      "index": 41,
      "value": 36.25,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "M",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "N",
      "label": "Administrative and support service activities",
      "index": 47,
      "value": 30.49,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "N",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "S951",
      "label": "Repair of computers and communication equipment",
      "index": 49,
      "value": 45.78,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "S951",
        "indic_is": "E_CRM1",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    }
  ]
}
